<template>
	<div class="showModal custom-modal">
		<div v-if="instruments[symbol]">
			<div class="buySell-popup text-center openBuySell" v-if="!placed && tempOrderId.length == 0">
				<span class="closePOP" @click="$parent.tradeMod = {}"><feather size="13px" type="x"></feather></span>
				<ul class="toggleButton d-inline-flex align-items-center justify-content-center">
					<!-- <li :class="(tab == 'modify')?'active':' '">
						<a @click.prevent="tab = 'modify'" class="greenBG" href="#">Modify</a>
					</li> -->
					<li :class="[{'actives':(tab == 'partial-close')}]" >
						<a class="redBG" href="#" v-if="lot <= instruments[symbol].other.Min_Trade_Size">{{$t('partial_close')}}</a>
						<a @click.prevent="tab = 'partial-close'" class="redBG" href="#" v-else>{{$t('partial_close')}}</a>
					</li>
				</ul>
				<div class="mainContent buy" v-if="tab == 'modify'">
					<ul class="btscure d-flex flex-wrap openOrder-list mb-3">	
						<li>{{$t('order')}} <span>#{{trade.TradeID}}</span></li>
						<li>{{$t('type')}} <span>{{(parseInt(trade.Side) == 1)?'Open Buy trade':'Open Sell Trade'}}</span></li>
						<li>{{$t('price')}} <span :class="sideClass[trade.Side]">{{trade.Price}} {{sideValue[trade.Side] || '-'}}</span></li>
						<li v-if="userSettings.position_size && userSettings.position_size == '1'">
                            {{$t('volume') }}  <span>{{Math.round(lot * contractSize * 100) / 100}} {{$t('units') }} </span>
                        </li>
						<li v-else>{{$t('volume')}} <span>{{lot}} {{$t('lot')}}</span></li>
					</ul>
					<form class="marKet form-data" @submit.prevent="modifyOrder()" v-if="parseInt(trade.Side) == 1">
						<div class="twoColmn">
							<div class="takePro mb-3 text-left">
								<label class="customCheckbox green">
	                                {{$t('stop_loss')}}
	                                <input type="checkbox" v-model="edit_stop"/>
	                                <span class="checkmark"></span>
	                            </label>
								<div class="form-fields" :class="[{'validation-error':submitted && errors.has('Stop loss')}]">
									<div class="d-flex align-items-center lightBC">
										<label>{{$t('stop_loss')}}<sup class="red" v-if="edit_stop">*</sup></label>
		                                <input type="number" :step="getStep(stop)" min="0" :placeholder="stopPlaceHolder" name="Stop loss" v-model="stop" v-validate="{'required':true, lessThen : instruments[symbol].A, greaterThen : 0}" v-if="edit_stop" :ref="'Stop lossInput'" @keyup="keyUp($event,'stop')"/>
		                                <input type="number" step="0.01" min="0" placeholder="0" name="Stop loss" v-model="stop" disabled v-else/>
		                                <span class="addHighLow" v-if="edit_stop">
                                            <a href="#" @click.prevent="changeTick('Stop lossInput',1,'stop')"><feather type="plus"></feather> </a>
                                            <a href="#" @click.prevent="changeTick('Stop lossInput',0,'stop')"><feather type="minus"></feather> </a>
                                        </span>
		                            </div>
	                                <span class="text-danger-error mt-0" v-if="submitted && errors.has('Stop loss')">
		                            	<span class="text-danger mt-0" v-if="errors.first('Stop loss').includes('decimal points')">{{$t('stop_loss_required')}}</span>
		                    			<span class="text-danger" v-else-if="errors.first('Stop loss').includes('is not valid')">{{$t('stop_loss_less_then')}} {{instruments[symbol].A}} {{$t('greater_then_zero')}} 0</span>
		                    			<span class="text-danger" v-else>{{ errors.first('Stop loss') }}</span>
		                            </span>
								</div>
								
							</div>
							<div class="takePro mb-3 text-left">
								<label class="customCheckbox green">
	                                {{$t('trailing_stop_loss')}}:
	                                <input type="checkbox" v-model="edit_trail"/>
	                                <span class="checkmark"></span>
	                            </label>
								<div class="form-fields" :class="[{'validation-error':submitted && errors.has('Trail')}]">
									<div class="d-flex align-items-center lightBC">
										<label>{{$t('trailing_stop')}}<sup class="red" v-if="edit_trail">*</sup></label>
		                                <input type="number" min="1" placeholder="100" name="Trail" v-model="trail" v-validate="'required|numeric|greaterThen:1'" v-if="edit_trail" :ref="'Trailing StopInput'"/>
		                                <input type="number" step="0.01" min="0" placeholder="0" name="Trail" v-model="trail" disabled v-else/>
		                                <span class="addHighLow" v-if="edit_trail">
                                            <a href="#" @click.prevent="changeTick('Trailing StopInput',1,'trail')"><feather type="plus"></feather> </a>
                                            <a href="#" @click.prevent="changeTick('Trailing StopInput',0,'trail')"><feather type="minus"></feather> </a>
                                        </span>
									</div>
									<span class="text-danger-error" v-if="submitted && errors.has('Trail')">
		                            	<span class="text-danger" v-if="errors.first('Trail').includes('decimal points')">{{$t('trailing_stop_required')}}</span>
		                    			<span class="text-danger" v-else-if="errors.first('Trail').includes('is not valid')">{{$t('trailing_stop_greater_one')}} 1</span>
		                    			<span class="text-danger" v-else>{{ errors.first('Trail') }}</span>
		                            </span>
								</div>
							</div>
							<div class="takePro mb-4 text-left">
								<label class="customCheckbox green">
	                                {{$t('Take Profit')}}:
	                                <input type="checkbox" v-model="edit_limit"/>
	                                <span class="checkmark"></span>
	                            </label>
								<div class="form-fields" :class="[{'validation-error':submitted && errors.has('limit')}]">
									<div class="d-flex align-items-center lightBC">
										<label>{{$t('Take Profit')}}<sup class="red" v-if="edit_limit">*</sup></label>
		                                <input type="number" :step="getStep(limit)" min="0" :placeholder="limitPlaceHolder" name="limit" v-model="limit" v-validate="{'required':true, greaterThen : instruments[symbol].A}" v-if="edit_limit" :ref="'Take ProfitInput'" @keyup="keyUp($event,'limit')"/>
		                                <input type="number" step="0.01" min="0" placeholder="0" v-model="limit" disabled v-else/>
		                                <span class="addHighLow" v-if="edit_limit">
                                            <a href="#" @click.prevent="changeTick('Take ProfitInput',1,'limit')"><feather type="plus"></feather> </a>
                                            <a href="#" @click.prevent="changeTick('Take ProfitInput',0,'limit')"><feather type="minus"></feather> </a>
                                        </span>
									</div>
									<span class="text-danger-error mt-0" v-if="submitted && errors.has('limit')">
		                            	<span class="text-danger" v-if="errors.first('limit').includes('decimal points')">{{$t('target_price_required')}}</span>
		                    			<span class="text-danger" v-else-if="errors.first('limit').includes('is not valid')">{{$t('greater_then')}} {{instruments[symbol].A}}</span>
		                    			<span class="text-danger" v-else>{{ errors.first('limit') }}</span>
		                            </span>
								</div>
							</div>
						</div>
					</form>
					<form class="marKet form-data" @submit.prevent="modifyOrder()" v-else>
						<div class="twoColmn">
							<div class="takePro mb-3 text-left">
								<label class="customCheckbox green">
	                                {{$t('stop_loss')}}
	                                <input type="checkbox" v-model="edit_stop"/>
	                                <span class="checkmark"></span>
	                            </label>
								<div class="form-fields" :class="[{'validation-error':submitted && errors.has('Stop loss')}]">
									<div class="d-flex align-items-center lightBC">
										<label>{{$t('rate')}}<sup class="red" v-if="edit_stop">*</sup></label>
		                                <input type="number" :step="getStep(stop)" :min="instruments[symbol].B" :placeholder="stopPlaceHolder" name="Stop loss" v-model="stop" v-validate="{'required':true, greaterThen : instruments[symbol].B}" v-if="edit_stop" :ref="'Stop lossInput'" @keyup="keyUp($event,'stop')"/>
		                                <input type="number" step="0.01" min="0" placeholder="0" name="Stop loss" v-model="stop" disabled v-else/>
		                                <span class="addHighLow" v-if="edit_stop">
                                            <a href="#" @click.prevent="changeTick('Stop lossInput',1,'stop')"><feather type="plus"></feather> </a>
                                            <a href="#" @click.prevent="changeTick('Stop lossInput',0,'stop')"><feather type="minus"></feather> </a>
                                        </span>
									</div>
									<span class="text-danger-error mt-0" v-if="submitted && errors.has('Stop loss')">
		                            	<span class="text-danger" v-if="errors.first('Stop loss').includes('decimal points')">{{$t('stop_loss_required')}}</span>
		                    			<span class="text-danger" v-else-if="errors.first('Stop loss').includes('is not valid')">{{$t('stop_loss_greater_then')}} {{instruments[symbol].B}}</span>
		                    			<span class="text-danger" v-else>{{ errors.first('Stop loss') }}</span>
		                            </span>
								</div>
							</div>
							<div class="takePro mb-3 text-left">
								<label class="customCheckbox green">
	                                {{$t('trailing_stop_loss')}}:
	                                <input type="checkbox" v-model="edit_trail"/>
	                                <span class="checkmark"></span>
	                            </label>
								<div class="form-fields" :class="[{'validation-error':submitted && errors.has('Trail')}]">
									<div class="d-flex align-items-center lightBC">
										<label>{{$t('trailing_stop')}}<sup class="red" v-if="edit_trail">*</sup></label>
		                                <input type="number" min="1" placeholder="100" name="Trail" v-model="trail" v-validate="'required|numeric|min_value:1'" v-if="edit_trail" :ref="'Trailing StopInput'" />
		                                <input type="number" step="0.01" min="0" placeholder="0" name="Trail" v-model="trail" disabled v-else/>
		                                <span class="addHighLow" v-if="edit_trail">
                                            <a href="#" @click.prevent="changeTick('Trailing StopInput',1,'trail')"><feather type="plus"></feather> </a>
                                            <a href="#" @click.prevent="changeTick('Trailing StopInput',0,'trail')"><feather type="minus"></feather> </a>
                                        </span>
									</div>
									<span class="text-danger-error mt-0" v-if="submitted && errors.has('Trail')">
		                            	<span class="text-danger" v-if="errors.first('Trail').includes('decimal points')">{{$t('trailing_stop_required')}}</span>
		                    			<span class="text-danger" v-else-if="errors.first('Trail').includes('is not valid')">{{$t('trailing_stop_greater_one')}} 1</span>
		                    			<span class="text-danger" v-else>{{ errors.first('Trail') }}</span>
		                            </span>
								</div>
							</div>
							<div class="takePro mb-4 text-left">
								<label class="customCheckbox green">
	                                {{$t('Take Profit')}}:
	                                <input type="checkbox" v-model="edit_limit"/>
	                                <span class="checkmark"></span>
	                            </label>
								<div class="form-fields" :class="[{'validation-error':submitted && errors.has('limit')}]">
									<div class="d-flex align-items-center lightBC">
										<label>{{$t('price')}}<sup class="red" v-if="edit_limit">*</sup></label>
		                                <input type="number" :step="getStep(limit)" min="0" :placeholder="limitPlaceHolder" name="limit" v-model="limit" v-validate="{'required':true, lessThen : instruments[symbol].B, greaterThen:0}" v-if="edit_limit" :ref="'Take ProfInput'"/>
		                                <input type="number" step="0.01" min="0" placeholder="0" v-model="limit" disabled v-else/>
		                                <span class="addHighLow" v-if="edit_limit">
                                            <a href="#" @click.prevent="changeTick('Take ProfInput',1,'limit')"><feather type="plus"></feather> </a>
                                            <a href="#" @click.prevent="changeTick('Take ProfInput',0,'limit')"><feather type="minus"></feather> </a>
                                        </span>
									</div>
									<span class="text-danger-error mt-0" v-if="submitted && errors.has('limit')">
		                            	<span class="text-danger" v-if="errors.first('limit').includes('decimal points')">{{$t('target_price_required')}}</span>
		                    			<span class="text-danger" v-else-if="errors.first('limit').includes('is not valid')">{{$t('target_price_less_then')}} {{instruments[symbol].B}} {{$t('greater_then_zero')}} 0</span>
		                    			<span class="text-danger" v-else>{{ errors.first('limit') }}</span>
		                            </span>
								</div>
							</div>
						</div>
					</form>
					<!-- <ul class="openOrder-list mb-4">	
						<li class="border-bottom">Required Margin <span>102.00 USD</span></li>
					</ul> -->
					<div class="submitButton d-flex align-items-center justify-content-center mb-3">
						<button href="#" class="btn appButton greenBG mr-2 justify-content-center" @click="modifyOrder()">{{$t('ok')}}</button>
						<button href="#" class="btn appButton redBG justify-content-center" @click="$parent.tradeMod = {}">{{$t('cancel')}}</button>
					</div>
				</div>
				<div class="mainContent sell" v-else-if="tab == 'partial-close'">
					<ul class="btscure d-flex flex-wrap openOrder-list mb-3">	
						<li>{{$t('order')}} <span>#{{trade.TradeID}}</span></li>
						<li>{{$t('price')}} <span :class="sideClass[trade.Side]">{{trade.Price}} {{sideValue[trade.Side] || '-'}}</span></li>
					</ul>
					<form class="marKet form-data" @submit.prevent="partialClose()">
						<div class="twoColmn">
							<div class="takePro mb-3 text-left">
								<p class="f-12 mb-3" v-if="userSettings.position_size && userSettings.position_size == '1'">
									{{$t('quantity')}}: {{Math.round(lot * contractSize * 100) / 100}} {{$t('units')}}
								</p>
								<p class="f-12 mb-3" v-else>{{$t('quantity')}}: {{lot}} {{$t('lot')}}</p>
								<div class="form-fields" :class="[{'validation-error':submitted && errors.has('quantity')}]">
									<div class="d-flex align-items-center lightBC">
										<label v-if="this.userSettings.position_size && this.userSettings.position_size == '1'">{{$t('quantity')}}({{$t('units') }})<sup class="red">*</sup></label>
                                        <label v-else>{{$t('quantity')}}({{$t('lots') }})<sup class="red">*</sup></label>
										<template  v-if="this.userSettings.position_size && this.userSettings.position_size == '1'">
											<input type="number" :step="getMinMaxUnits(0)" :min="getMinMaxUnits(0)" placeholder="1000" name="units" v-model="units" v-validate="{'required': true,'max_value':getMinMaxUnits(1),'min_value':getMinMaxUnits(0),'divisibleBy':getMinMaxUnits(0)}" autocomplete="off" ref="unitsInput" />
											<span class="addHighLow">
												<a href="javascript:void(0)" @click.stop="changeTick('unitsInput',1,'units')"><feather type="plus"></feather> </a>
												<a href="javascript:void(0)" @click.stop="changeTick('unitsInput',0,'units')"><feather type="minus"></feather> </a>
											</span>
										</template>
										<template v-else>
											<input class="lot-limit" type="number" step="0.01" :min="instrument.other.Min_Trade_Size" placeholder="0.01" name="quantity" v-model="quantity" 
												v-validate="{'required': true,'lessThen':lot,'min_value':instrument.other.Min_Trade_Size }" autocomplete="off" ref="volumeInput"/>
											<span class="addHighLow">
												<a href="javascript:void(0)" @click.stop="changeTick('volumeInput',1,'quantity')"><feather type="plus"></feather> </a>
												<a href="javascript:void(0)" @click.stop="changeTick('volumeInput',0,'quantity')"><feather type="minus"></feather> </a>
											</span>
										</template>
									</div>
									<span class="text-danger-error mt-0" v-if="submitted && errors.has('quantity')">
		                            	<span class="text-danger" v-if="errors.first('quantity').includes('decimal points')">{{$t('volume_required')}}</span>
		                    			<span class="text-danger" v-else-if="errors.first('quantity').includes('is not valid')">{{$t('volume_less_then')}} {{lot}}</span>
		                    			<span class="text-danger" v-else>{{ errors.first('quantity') }}</span>
		                            </span>
								</div>
							</div>
						</div>
						<div class="submitButton d-flex align-items-center justify-content-center my-3">
							<button href="#" class="btn appButton greenBG mr-2 justify-content-center" @click="partialClose()" :disabled="lot <= 0.01">{{$t('submit')}}</button>
							<button href="#" class="btn appButton redBG justify-content-center" @click="$parent.tradeMod = {}">{{$t('cancel')}}</button>
						</div>
					</form>
					<div class="position-relative form-fields">
						<ul class="btscure d-flex flex-wrap openOrder-list">	
							<li class="border-bottom">{{$t('take_profit')}} <span>{{this.stop || '-'}}</span></li>
							<li class="border-bottom">{{$t('stop_loss')}} <span>{{this.limit || '-'}}</span></li>
							<li class="border-bottom w-100">{{$t('PNL')}}
								<span :class="[{'red':getPl(trade,instruments[trade.Symbol])<0,'green':getPl(trade,instruments[trade.Symbol])>0}]">
									{{getPl(trade,instruments[trade.Symbol])}}
								</span>
							</li>
						</ul>
						<span class="text-danger-show red font-weight-bold mt-0" v-if="lot <= 0.01">{{$t('lot_size_partial')}}</span>
					</div>
				</div>
			</div>
			<div class="buySell-popup text-center openBuySell" v-else-if="placed && tempOrderId.length > 0 && hasOrdersMsg().length == 0">
		    	<span class="closePOP" @click="$parent.tradeMod = {}"><feather size="13px" type="x"></feather></span>
		    	<div class="ppSuccess-icon text-center mt-3 mb-2">
	                <feather size="28px" type="clock"></feather>
	            </div>
		    	{{$t('placed_order_pending_wait')}}
		    </div>
		    <div class="buySell-popup text-center openBuySell" v-else-if="hasOrdersMsg().length > 0">
		    	<div v-for="respId in tempOrderId">
			    	<span class="closePOP" @click="$parent.tradeMod = {}"><feather size="13px" type="x"></feather></span>
			    	<div class="ppSuccess-icon text-center mt-3 mb-2" v-if="wsOrder[respId]">
		                <feather size="28px" type="check-circle" v-if="wsOrder[respId].stat == 'OK'"></feather>
		                <feather size="28px" type="alert-triangle" v-else></feather>
		            </div>
			    	<h3 :class="(wsOrder[respId].stat == 'OK')?'green':'red'" v-html="wsOrder[respId].resp_msg" v-if="wsOrder[respId]"></h3>
	            </div>
		    	<a href="#" class="btn appButton linkBG justify-content-center mt-4 mx-auto" @click.prevent="$parent.tradeMod = {}">{{$t('go_to_order')}}</a>
		    </div>
	    </div>
	    <div class="buySell-popup text-center openBuySell" v-else>
	    	<span class="closePOP" @click="$parent.tradeMod = {}"><feather size="13px" type="x"></feather></span>
	    	<div class="ppSuccess-icon text-center mt-3 mb-2">
                <feather size="28px" type="clock"></feather>
            </div> 
	    	<!-- Please wait While order is loading... -->
	    	<app-loader/>
	    </div>
	</div>
</template>
<script>
import { Const } from '@/plugins/vue-provider-cache/const.mod'
import { commonAllmixins } from '@/plugins/commonAll'
const product_type = process.env.product_type;
const product = process.env.product;
import { Validator } from 'vee-validate';
const paramNames = ['val'];
const divisibleByCheck = (value, val) => { 
    const tolerance = 1e-10; // Tolerance for floating-point comparison
    if (!val) return false; // Prevent division by undefined or zero
    const quotient = value / val;
    return Math.abs(quotient - Math.round(quotient)) < tolerance;
};
const divisibleBy = (value, [val] = {}) => { 
    const tolerance = 1e-10; // Tolerance for floating-point comparison
    const quotient = value / val;
    // return Math.abs((value / val) % 1) < tolerance;
    return Math.abs(quotient - Math.round(quotient)) < tolerance;
};
Validator.extend('divisibleBy', divisibleBy, { paramNames });
export default {
    name: 'App-modify-open-order',
    mixins: [commonAllmixins],
    data() {
        return {
        	tab: 'partial-close', // modify, partial-close
        	placed:false,
        	tempOrderId: [],
            submitted: false,
			/*orderType:{
				'S' : 'Stop',
				'L' : 'Limit',
				'ES' : 'Entry Stop',
				'EL' : 'Entry Limit' 
			},*/
			sideClass:{
                '0':'red',
                '1':'green',
            },
            sideValue:{
                '0':'Sell',
                '1':'Buy',
            },
            lot: '',
            quantity: '',
			units: '',
			price: '',
			stop: '',
			stopPlaceHolder: '',
			edit_stop: false,
			trail: '',
			edit_trail: false,
			limit: '',
			limitPlaceHolder: '',
			edit_limit: false,
			comment: '',
			symbol: '',
			currency_pair: '',
        }
    },
    props:['trade'],
    watch:{
		units(val){
            const rounded = Math.round(val * 100) / 100;
            if (val !== rounded) { this.units = rounded; return; }
            const qty = rounded / this.contractSize;
            const minTradeSize = this.instrument.other.Min_Trade_Size;
            if (this.quantity !== qty && divisibleByCheck(qty, minTradeSize)) {
                this.quantity = Math.round(qty * 100) / 100;
            }
        },
    	quantity(val){
			let upper = 3, lower = 3;
    		try{ upper = this.instruments[this.symbol].other.Max_Trade_Size.length}catch(e){}
    		try{ lower = this.instruments[this.symbol].other.Min_Trade_Size.split('.')[1].length}catch(e){}
			this.quantity = val.toString()
				.replace(/[^\d.]/g, '')             // numbers and decimals only
              	.replace(this.getUpper(upper), '$1')   // not more than 2 digits at the beginning
              	.replace(/(\..*)\./g, '$1')         // decimal can't exist more than once
              	.replace(this.getLower(lower), '$1');    // not more than 4 digits after decimal
			if(this.units != val * this.contractSize){
                this.units = val * this.contractSize;
            }
    	},
    	stop(val){
    		this.changeValidation('stop',val)
    	},
    	trail(val){
			this.trail = val.toString()
				.replace(/[^\d]/g, '')             	// numbers only
              	.replace(/(^[\d]{20})[\d]/g, '$1')	// not more than 2 digits at the beginning/(^[\d]{6})[\d]/g
    	},
    	limit(val){
			this.changeValidation('limit',val)
    	},
    	edit_stop(val){
    		if(val){
				this.stop = this.trade.SL.Price || ''
				this.edit_trail = false
				this.stopPlaceHolder = this.instruments[this.symbol].A
    		}else{
    			this.stop = ''
    		}
    	},
    	edit_trail(val){
    		if(val){
				this.trail = this.trade.Trail.Trail || ''
				this.edit_stop = false
    		}else{
    			this.trail = ''
    		}
    	},
    	edit_limit(val){
    		if(val){
				this.limit = this.trade.TP.Price || ''
				this.limitPlaceHolder = this.instruments[this.symbol].A
    		}else{
    			this.limit = ''
    		}
    	}
    },
    methods:{
		getMinMaxUnits(type){
            if(type) return parseFloat(this.instruments[this.currency_pair].other.Max_Trade_Size) * this.contractSize;
            else return parseFloat(this.instruments[this.currency_pair].other.Min_Trade_Size) * this.contractSize;
        },
    	hasOrdersMsg(){
    		let _that = this
    		return this.tempOrderId.filter(val=> _that.wsOrder.hasOwnProperty(val))
    	},
    	changeValidation(variablName,val){
    		let upper = 5, lower = 5;
    		try{ upper = this.instruments[this.symbol].B.split('.')[0].length}catch(e){}
    		try{ lower = this.instruments[this.symbol].other.Tick_Size.split('.')[1].length}catch(e){}
			this[variablName] = val.toString()
				// .replace(/[^\d.]/g, '')             	// numbers and decimals only
              	// .replace(this.getUpper(upper), '$1')	// not more than 2 digits at the beginning
              	// .replace(/(\..*)\./g, '$1')				// decimal can't exist more than once
              	// .replace(this.getLower(lower), '$1');	// not more than 4 digits after decimal
    	},
    	getUpper(val){
    		if(val == 1){ return /(^[\d]{1})[\d]/g}
    		if(val == 2){ return /(^[\d]{2})[\d]/g}
    		if(val == 3){ return /(^[\d]{3})[\d]/g}
    		if(val == 4){ return /(^[\d]{4})[\d]/g}
    		if(val == 5){ return /(^[\d]{5})[\d]/g}
    		if(val == 6){ return /(^[\d]{6})[\d]/g}
    		if(val == 7){ return /(^[\d]{7})[\d]/g}
    		if(val == 8){ return /(^[\d]{8})[\d]/g}
    		else{ return /(^[\d]{0})[\d]/g }
    	},
    	getLower(val){
    		if(val == 1){ return /(\.[\d]{1})./g}
    		if(val == 2){ return /(\.[\d]{2})./g}
    		if(val == 3){ return /(\.[\d]{3})./g}
    		if(val == 4){ return /(\.[\d]{4})./g}
    		if(val == 5){ return /(\.[\d]{5})./g}
    		if(val == 6){ return /(\.[\d]{6})./g}
    		if(val == 7){ return /(\.[\d]{7})./g}
    		if(val == 8){ return /(\.[\d]{8})./g}
    		else{ return /(^[\d]{0})[\d]/g }
    	},
    	getStep(val){
    		let data = this.instruments[this.symbol].A
    		if(val == '' || parseFloat(val) == 0){
                return (parseFloat(data)).toString()
            }else if(val && data.toString().includes('.')){
    			return 1/Math.pow(10, data.toString().split('.')[1].length)
    		}else{
    			return '1'
    		}
    	},
    	partialClose(){
    		if(this.lot <= 0.01){
    			return
    		}
    		var _that = this
    		this.submitted =  true
    		this.tempOrderId =  []
			_that.$validator.validate().then(valid => {
				if (valid && !_that.orderPlacedWait) {
					_that.$store.commit('SET_WS_ORDER',{})
		    		const tempOrderId = new Date().getTime()
	    			_that.submitted =  false
	    			let orderJson = {
						"symbol" : _that.symbol,
		                "trade" : _that.trade.TradeID,
		                "quantity" : parseFloat(_that.quantity)*parseFloat(_that.instruments[_that.symbol].other.market_ContractSize),
		                "tempOrderId" : tempOrderId,
						'localParams':_that
					}
					if(this.userSettings.position_size && this.userSettings.position_size == '1'){
						orderJson.positionSize = "1";
						orderJson.tradeType = "partial";
					}
					console.log('closeTrade->',orderJson)
					_that.placed = true
					this.tempOrderId.push(orderJson.tempOrderId)
		            _that.$store.getters[Const.GET_PROVIDERS]['priceFeed'].seeders['S_PF_PF'].closeTrade(orderJson)
				}
			});
    	},
    	modifyOrder(){
    		let change = false
    		var _that = this
    		this.submitted =  true
    		this.tempOrderId =  []
    		_that.$validator.validate().then(valid => {
				if (valid && !_that.orderPlacedWait) {
					_that.$store.commit('SET_WS_ORDER',{})
	    			_that.submitted =  false
	    			if(_that.trade.SL.Price && !_that.edit_stop){
	    				_that.cancleOrder(_that.trade.SL)
	    				change = true
	    			}else if(_that.stop && _that.stop != _that.trade.SL.Price){
						const tempOrderId = new Date().getTime() + '_stop'
						let orderJson = {
							"trade" : _that.trade.TradeID,
							"order" : '',
							"price" : parseFloat(_that.stop || 0),
							"tempOrderId" : tempOrderId,
							'localParams' : _that
						}
						// console.log('place stop',orderJson)
						_that.tempOrderId.push(orderJson.tempOrderId)
						_that.$store.getters[Const.GET_PROVIDERS]['priceFeed'].seeders['S_PF_PF'].placestop(orderJson)
						change = true
					}
					if(_that.trade.Trail.Trail && !_that.edit_trail){
						_that.cancleOrder(_that.trade.Trail)
						change = true
	    			}else if(_that.trail && _that.trail != _that.trade.Trail.Trail){
						const tempOrderId = new Date().getTime() + '_trail'
						let orderJson = {
							"trade" : _that.trade.TradeID,
							"order" : '',
							"trail" : parseFloat(_that.trail || 0),
							"tempOrderId" : tempOrderId,
							'localParams' : _that
						}
						// console.log('place trail',orderJson)
						_that.tempOrderId.push(orderJson.tempOrderId)
						_that.$store.getters[Const.GET_PROVIDERS]['priceFeed'].seeders['S_PF_PF'].placeTrail(orderJson)
						change = true
					}
					if(_that.trade.TP.Price && !_that.edit_limit){
						_that.cancleOrder(_that.trade.TP)
						change = true
	    			}else if(_that.limit && _that.limit != _that.trade.TP.Price){
						const tempOrderId = new Date().getTime() + '_limit'
						let orderJson = {
							"trade" : _that.trade.TradeID,
							"order" : '',
							"price" : parseFloat(_that.limit || 0),
							"tempOrderId" : tempOrderId,
							'localParams' : _that
						}
						// console.log('place limit',orderJson)
						_that.tempOrderId.push(orderJson.tempOrderId)
						_that.$store.getters[Const.GET_PROVIDERS]['priceFeed'].seeders['S_PF_PF'].placeLimit(orderJson)
						change = true
					}
					if(!change){
						// console.log('please change before Modify Order')
						_that.displayError('Please Make changes before Modify Order','error')
						return
					}
					_that.placed = true
					// _that.orderPending = orderJson
					// this.tempOrderId = this.orderPending.tempOrderId
				}
			});
    	},
    	cancleOrder(item){
            const tempOrderId = new Date().getTime()
            let orderJson = {
				"order_id" : item.OrderID,
				"tempOrderId" : tempOrderId,
				'localParams':this
			}
            this.tempOrderId.push(tempOrderId)
            this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].seeders['S_PF_PF'].cancelOrder(orderJson)
        },
    	successWs(){
			this.placed = true
        },
        failedWs(){
			this.displayError('faild to Modify order','error')
			this.placed = false
			this.$store.commit('SET_WS_ORDER',{})
        },
    	displayError(getMessage,type){
			this.$notify({
				group: 'foo',
				type: (type && type == null)?'error':type,
				text: getMessage,
				duration: 4000,
				closeOnClick: true
			});
		},
		getPl(list,instruments){
    		return this.getProfitLoss(this.accountList.Currency, list, instruments, this.instruments)
    	},
		getProfitLoss(accountCurrency, order, symbol, isins) {
            try {
                if(symbol==undefined) return 0
                else{
                    let quantity = order.Quantity;
                    let commission = parseFloat(order.Commission || 0);
                    let interest = parseFloat(order.Interest || 0);
                    let price = parseFloat(order.Price);
                    let askPrice = parseFloat(symbol.A);
                    let bidPrice = parseFloat(symbol.B);

                    let BSprice = order.Side === 1 ? bidPrice - price : price - askPrice;

                    let convertedAmount = parseFloat(this.convertCurrencyNew(accountCurrency, symbol, this.instruments, order.Side, order.Symbol));
                    
                    let toFixedValue = accountCurrency === 'BTC' ? 8 : 2;
                    let pnl = (BSprice * quantity * convertedAmount) + commission + interest;

                    return pnl.toFixed(toFixedValue);
                }
                
            } catch (e) {
                // console.log(e);
                return 0;
            }
        },
		convertCurrencyNew(accountCurrency, symbol, isins, side, orderSymbol) {
            symbol.other.base_currency = symbol.other.base_currency.split('_V')[0];
            const base = symbol.other.base_currency;
            const acc = accountCurrency //.toUpperCase();
            const product = product_type; // assuming it's globally accessible

            if (acc === base) return 1;

            const getPossibleKeys = (cur1, cur2) => [
                `${cur1}/${cur2}`,
                `${cur1}${cur2}.`,
                `${cur1}${cur2}_`,
                `${cur1}${cur2}`
            ];

            const tryGetRateFromPairs = (cur1, cur2, invert = false) => {
                if(cur1 == cur2) return 1
                const keys = getPossibleKeys(cur1, cur2);
				if ((cur1 === 'BTC' && cur2 === 'USD') || (cur1 === 'USD' && cur2 === 'BTC')) keys.push('Bitcoin');
                for (const key of keys) {
                    const item = isins[key];
                    if (item && item.A) return invert ? 1 / item.A : item.A;
                }
                return null;
            };

            // 1. Try direct and inverse rates
            let rate = tryGetRateFromPairs(acc, base, true) || tryGetRateFromPairs(base, acc, false);
            if (rate) return rate;

            // 2. Use USD as intermediary
            const toUSD = tryGetRateFromPairs(base, 'USD' + product) || tryGetRateFromPairs('USD', base + product, true);
            const fromUSD = 
                tryGetRateFromPairs(acc, 'USD' + product, true) ||
                tryGetRateFromPairs('USD', acc + product) ||
                tryGetRateFromPairs(acc, product);

            // console.log('===fromUSD==>', toUSD/fromUSD)

            if (fromUSD && toUSD) return ((toUSD == 1) ? toUSD/fromUSD : fromUSD * toUSD);

            // 3. Fallback using symbol directly
            const fallbackKey = acc + product;
            if (isins[fallbackKey]) {
                return Number(symbol.A || 1) / Number(isins[fallbackKey].A || 1);
            }

            return 1; // final fallback
        },
    },
    computed:{
		contractSize(){
            return (this.currencyPairs.find(v=> v.mn == this.currency_pair) || {}).market_ContractSize || 10000;
        },
    	instruments(){
    	    try {
	            this.$store.getters[Const.GET_HEARTBEATS]['priceFeed']
	            return this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].iCache.asKeysValueArrayAll()
	        } catch (ex) {                
	            return []
	        }
	    },
    	instrument(){
    	    return this.instruments[this.symbol] || {}
	    },
    },
    /*mounted(){
        $('.lot-limit').on('input', function() {
        	console.log(this.value)
            this.value = this.value
              .replace(/[^\d.]/g, '')             // numbers and decimals only
              .replace(/(^[\d]{3})[\d]/g, '$1')   // not more than 2 digits at the beginning
              .replace(/(\..*)\./g, '$1')         // decimal can't exist more than once
              .replace(/(\.[\d]{2})./g, '$1');    // not more than 4 digits after decimal
        });
    },*/
    created(){
    	// this.$store.commit('SET_WS_ORDER',{})
    	// console.log(this.trade)
    	this.price = this.trade.Price
    	let lotBy = 100000;
    	this.symbol = this.trade.Symbol;
    	this.currency_pair = this.trade.Symbol;
    	this.trail = this.trade.Trail.Trail || '';
    	if(this.trail){
    		this.edit_trail = true
    	}else{
	    	this.stop = this.trade.SL.Price || '';
	    	if(this.stop){
	    		this.edit_stop = true
	    	}
    	}
    	this.limit = this.trade.TP.Price || '';
    	if(this.limit){
    		this.edit_limit = true
    	}
    	try{
    		lotBy = this.currencyPairs.filter(val=>val.isinid.includes( this.symbol))[0].market_ContractSize || 100000
    	}catch(e){}
		this.lot = this.trade.Quantity?(this.trade.Quantity / lotBy):0
		this.quantity = this.trade.Quantity?(this.trade.Quantity / lotBy):0
    }
}
</script>
<style>
	li.disabled {
	    cursor: not-allowed;
	    opacity: 0.3;
	}
	a.redBG.disabled {
	    cursor: not-allowed;
	}
</style>


// WEBPACK FOOTER //
// src/components/website/shared/order/modify-order/open-order-modify.vue